import { render, staticRenderFns } from "./CptCodeScopeOfInclusion.vue?vue&type=template&id=5d62eee3&scoped=true&"
var script = {}
import style0 from "./CptCodeScopeOfInclusion.vue?vue&type=style&index=0&id=5d62eee3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d62eee3",
  null
  
)

export default component.exports